import { PrismicRichText } from '@components/PrismicRichText';
import { RichTextField, isFilled } from '@prismicio/client';
import { ReactElement, useMemo } from 'react';
import {
  PrismicTextAlignmentField,
  PrismicTitleStyleField,
} from '@monofront/types';

type PrismicTitleProps = {
  field: RichTextField;
  titleStyleField: PrismicTitleStyleField;
  titleAlignmentField?: PrismicTextAlignmentField;
  titleDecorationElement?: ReactElement<any>;
  className?: string;
};

export const PrismicTitle = ({
  field,
  titleStyleField,
  titleAlignmentField,
  titleDecorationElement,
  className,
}: PrismicTitleProps) => {
  const titleStyle = (() => {
    if (!isFilled.select(titleStyleField)) {
      return '';
    }

    switch (titleStyleField ?? 'default') {
      case 'Display':
        return 'tw-lf-title-display';
      case 'XL':
        return 'tw-lf-title-xl';
      case 'L':
        return 'tw-lf-title-lg';
      case 'M':
        return 'tw-lf-title-md';
      case 'S':
        return 'tw-lf-title-sm';
      case 'Subtitle':
        return 'tw-lf-subtitle-md';
      default:
        return '';
    }
  })();

  const classNames = useMemo(
    () => ({
      heading1: titleStyle + (className ? ` ${className}` : ''),
      heading2: titleStyle + (className ? ` ${className}` : ''),
      heading3: titleStyle + (className ? ` ${className}` : ''),
      heading4: titleStyle + (className ? ` ${className}` : ''),
      heading5: titleStyle + (className ? ` ${className}` : ''),
      heading6: titleStyle + (className ? ` ${className}` : ''),
    }),
    [titleStyle, className],
  );

  return (
    <PrismicRichText
      field={field}
      classNames={classNames}
      textAlignmentField={titleAlignmentField}
      titleDecorationElement={titleDecorationElement}
    />
  );
};
